module.exports = __webpack_public_path__ + "static/media/ow3.ec16c5bc.webp";